import { ArrowRight } from "lucide-react";
import { SmartLink } from "./SiteChrome";

export function PageHero({ content, home = false, variant = "" }) {
  const variantClass = variant ? ` page-hero-${variant}` : "";

  return (
    <section id={content.anchorId} className={`page-hero${home ? " page-hero-home" : ""}${variantClass}`} style={{ "--hero-image": `url(${content.image})`, "--hero-position": content.imagePosition }}>
      <div className="hero-overlay" aria-hidden="true" />
      <div className="hero-content">
        {content.eyebrow && <p className="eyebrow">{content.eyebrow}</p>}
        <h1>{content.headline}</h1>
        <p className="hero-subheading">{content.subheading}</p>
        <div className="hero-actions">
          {content.ctas.map((cta) => (
            <SmartLink key={cta.label} target={cta.target} className={`button ${cta.style === "primary" ? "button-primary" : "button-secondary"}`}>
              {cta.label}
            </SmartLink>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ContentSection({ children, className = "", tone = "light", heading, intro }) {
  return (
    <section className={`content-section tone-${tone} ${className}`}>
      <div className="section-inner">
        {heading && <h2>{heading}</h2>}
        {intro && <p className="section-intro">{intro}</p>}
        {children}
      </div>
    </section>
  );
}

export function JourneyOverview({ content }) {
  return (
    <ContentSection className="journey-section" tone="ink" heading={content.heading}>
      <ol className="journey-grid">
        {content.stages.map((stage) => (
          <li className="journey-stage" key={stage.number}>
            <span className="stage-number">{stage.number}</span>
            <h3>{stage.title}</h3>
            <p>{stage.problem}</p>
            <p>{stage.intervention}</p>
            <p className="stage-outcome"><strong>Outcome:</strong> {stage.outcome}</p>
            <SmartLink className="text-link" target={stage.href}>See this stage <ArrowRight aria-hidden="true" size={17} /></SmartLink>
          </li>
        ))}
      </ol>
      <div className="journey-closing">
        <p>{content.closing}</p>
        <SmartLink className="button button-primary" target={content.cta.target}>{content.cta.label}</SmartLink>
      </div>
    </ContentSection>
  );
}

export function NewsletterBand({ content }) {
  return (
    <section className="newsletter-band" aria-labelledby="newsletter-heading">
      <div className="newsletter-inner">
        <div><p className="eyebrow">The LevelUp360 Newsletter</p><h2 id="newsletter-heading">{content.heading}</h2><p>{content.body}</p></div>
        <SmartLink className="button button-primary" target={content.cta.target}>{content.cta.label}</SmartLink>
      </div>
    </section>
  );
}
